import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SkipContentComponent } from './skip-content.component';

@NgModule({
  declarations: [SkipContentComponent],
  imports: [CommonModule],
  exports: [SkipContentComponent]
})
export class SkipContentModule {}
